import { ArrowRightIcon } from 'assets/icons';
import cx from 'classnames';
import * as React from 'react';
import { styled, useTheme } from 'styled-components';

import styles from './styles.module.scss';

const StyledIconWrapper = styled.div`
  background-color: ${({ theme }) => theme.components.pages.home?.placeOrderFooter?.backgroundColor};
`;

const StyledArrowRightIcon = styled(ArrowRightIcon)<RightArrowIconProps>`
  path {
    fill: ${({ theme, arrowColor }) => arrowColor ?? theme.text.color};
  }
`;

interface RightArrowIconProps extends React.SVGProps<SVGSVGElement> {
  arrowColor?: string;
}

const PrimaryButtonIcon = () => {
  const theme = useTheme();
  const isRTL = theme.direction === 'rtl';

  return (
    <StyledIconWrapper className={cx('margin-start-auto d-flex justify-content-center align-items-center', styles.icon)}>
      <StyledArrowRightIcon arrowColor={theme.components.pages.home?.placeOrderFooter?.arrowColor} className={isRTL ? 'transform-180' : ''} />
    </StyledIconWrapper>
  );
};

export default PrimaryButtonIcon;
